import React, { useState } from "react";

import "../../../../Assets/CSS/bulkorder.css";

import "../../oms.css";

import Up from "../../../../Assets/Images/OMS/up.svg";
import Down from "../../../../Assets/Images/OMS/down.svg";

import Supplier from "../../../../Assets/Images/OMS_New/payment (1).svg";
import { useFormik } from "formik";
import AddNewPaymentDetails from "../../AddNewPaymentDetails";
import { Button } from "@mui/material";
import AddMore from "../../../../Assets/Images/OMS/AddMore.svg";


function PaymentDetailsBuyerForm({
  paymentData,
  omsData,
  getOMSData,
  orderId,
}) {
  const [buyerPaymentDetails, setBuyerPaymentDetails] = useState(false);
  const [openPayment, setOpenPayment] = useState(false);

  const jsonArray = paymentData?.partial_payment_data?.map((jsonString) => {
    try {
      return JSON.parse(jsonString);
    } catch {
      return {};
    }
  });

  const validate = (values) => {
    const errors = {};
    if (!values.supplier_Name) {
      errors.supplier_Name = " Supplier name is required";
    } else if (values.supplier_Name.length > 35) {
      errors.firstName = "Must be 35 characters or less";
    }

    return errors;
  };
  const formik = useFormik({
    initialValues: { supplier_Name: "", billed_to: "" },
    validate,
    onSubmit: (values) => {
      console.log(values);
    },
  });

  const handleOpenPayment = () => {
    setOpenPayment(true);
  };
  const handleClosePayment = () => {
    setOpenPayment(false);
  };

  return (
    <div className="shadow-lg m-2 p-2 pb-2 rounded-lg">
      <div className="flex flex-col sm:flex-row justify-between">
        <div className="font-medium text-cyan-950 text-md flex gap-1">
          {" "}
          <img src={Supplier} alt="" />
          <div className="ms-1">Payment Details</div>
          {omsData?.order_type === "FOR" && omsData?.buyer_unloading && (
            <Button className="m-0 p-0" onClick={() => handleOpenPayment()}>
              <img src={AddMore} alt="" />{" "}
              <span className="ml-2 normal-case">Payment Request</span>
            </Button>
          )}
        </div>
        <div>
          {buyerPaymentDetails ? (
            <div className="font-medium text-cyan-950 text-lg mt-2">
              <img
                src={Up}
                alt=""
                role="button"
                onClick={() => setBuyerPaymentDetails(!buyerPaymentDetails)}
              />
            </div>
          ) : (
            <div className="font-medium text-cyan-950 text-lg mt-2">
              <img
                src={Down}
                alt=""
                role="button"
                onClick={() => setBuyerPaymentDetails(!buyerPaymentDetails)}
              />
            </div>
          )}
        </div>
      </div>
      <div>
        <hr className="font-bold text-neutral-500 bg-gray-900 h-0.5" />
      </div>
      <div>
        {buyerPaymentDetails ? (
          <></>
        ) : (
          <div>
            {/*<form onSubmit={formik.handleSubmit}>
                        <div className="row mt-3">
                          <div className="col col-md-8 col-lg-8 col-sm-8">
                            <FormGroup className="">
                              <div className="flex gap-3">
                                <InputLabel className="mt-2">
                                  Has buyer paid in advance
                                </InputLabel>
                                <FormControlLabel
                                  control={<Checkbox />}
                                  label="Yes"
                                />
                                <FormControlLabel
                                  control={<Checkbox />}
                                  label="No"
                                />
                              </div>
                            </FormGroup>
                            {formik.errors.supplier_Name ? (
                              <div className="text-red-600 text-sm">
                                {formik.errors.supplier_Name}
                              </div>
                            ) : null}
                          </div>
                        </div>
                        <div className="row mt-3">
                          <div className="col col-md-6 col-lg-6 col-sm-6">
                            <TextField
                              size="small"
                              fullWidth
                              name="Deductions"
                              // onChange={formik.handleChange}
                              // onBlur={formik.handleBlur}
                              // value={formik.values.supplier_Name}
                              label="Deductions"
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <img src={Rupies} alt="" />
                                  </InputAdornment>
                                ),
                              }}
                            />
                            {formik.errors.supplier_Name ? (
                              <div className="text-red-600 text-sm">
                                {formik.errors.supplier_Name}
                              </div>
                            ) : null}
                          </div>
                          <div className="col col-md-6 col-lg-6 col-sm-6">
                            <TextField
                              size="small"
                              fullWidth
                              name="Total Amount from buyer"
                              label="Total Amount from buyer"
                              // onBlur={formik.handleBlur}
                              // onChange={formik.handleChange}
                              // value={formik.values.billed_to}
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <img src={Rupies} alt="" />
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </div>
                        </div>
                        <div className="row mt-3">
                          <div className="col col-md-6 col-lg-6 col-sm-6">
                            <div className="flex gap-2">
                              <InputLabel className="mt-2">Date</InputLabel>
                              <TextField
                                size="small"
                                type="date"
                                name="date"
                                // onChange={formik.handleChange}
                                // onBlur={formik.handleBlur}
                                // value={formik.values.supplier_Name}
                                label=""
                              />
                              {formik.errors.supplier_Name ? (
                                <div className="text-red-600 text-sm">
                                  {formik.errors.supplier_Name}
                                </div>
                              ) : null}
                            </div>
                          </div>
                          <div className="col col-md-6 col-lg-6 col-sm-6">
                            <TextField
                              size="small"
                              fullWidth
                              name="UTR Number"
                              label="UTR Number"
                              // onBlur={formik.handleBlur}
                              // onChange={formik.handleChange}
                              // value={formik.values.billed_to}
                            />
                          </div>
                        </div>

                        <hr className="font-bold text-neutral-500 bg-gray-900 h-0.5" />
                        <div className="flex gap-2 justify-between">
                          <h6 className="mt-1">Auto Generate Credit Note</h6>
                          <img src={PlainRight} alt="" className="ms-5" />
                          <div className=" ">
                            <Button type="submit">
                              <img src={Next} alt="" role="button" />
                            </Button>
                          </div>
                        </div>
                      </form>*/}
            {!jsonArray || jsonArray?.length === 0 ? (
              <div className="mb-3 mt-3">No Payment Details Available</div>
            ) : (
              jsonArray?.map((each, index) => (
                <div key={index} className="mb-3 border border-3 p-2">
                  <h1 className="text-sm mb-3">Payment {index + 1}</h1>
                  <div className="grid grid-cols-2 gap-4">
                    <div className="mb-3">
                      <label
                        for="operation_status"
                        className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                      >
                        Operation Status
                      </label>
                      <input
                        type="text"
                        id="operation_status"
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        name="operation_status"
                        value={
                          each?.operation_status ? each?.operation_status : "NA"
                        }
                        disabled
                      />
                    </div>
                    <div className="mb-3">
                      <label
                        for="finance_status"
                        className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                      >
                        Operation Status
                      </label>
                      <input
                        type="text"
                        id="finance_status"
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        name="finance_status"
                        value={each?.finance_status}
                        disabled
                      />
                    </div>
                    <div className="mb-3">
                      <label
                        for="amount_collected"
                        className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                      >
                        Amount Collected (Rs)
                      </label>
                      <input
                        type="text"
                        id="amount_collected"
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        name="amount_collected"
                        value={each?.amount_collected}
                        disabled
                      />
                    </div>
                    <div className="mb-3">
                      <label
                        for="payment_status"
                        className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                      >
                        Payment Status
                      </label>
                      <input
                        type="text"
                        id="payment_status"
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        name="payment_status"
                        value={each?.payment_status}
                        disabled
                      />
                    </div>
                    <div className="mb-3">
                      <label
                        for="amount_collected_date"
                        className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                      >
                        Amount Collected Date
                      </label>
                      <input
                        type="text"
                        id="amount_collected_date"
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        name="amount_collected_date"
                        value={each?.amount_collected_date}
                        disabled
                      />
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        )}
      </div>
      <AddNewPaymentDetails
        open={openPayment}
        handleClose={handleClosePayment}
        getOMSData={getOMSData}
        orderId={orderId}
      />
    </div>
  );
}

export default PaymentDetailsBuyerForm;
